import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const PagesModule = lazy(loadModule);

export default PagesModule;
